// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PortalChevronDown = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="m39.941 48 22.81-22.81a2.454 2.454 0 1 0-3.47-3.47L33 48l26.28 26.28c.48.48 1.108.72 1.735.72a2.454 2.454 0 0 0 1.736-4.19L39.942 48Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default PortalChevronDown;
